module.exports = __webpack_public_path__ + "6fbc02a44823c12395ef5c0a0460b292.pdf";